import React, { useCallback, useMemo, useRef, useState } from "react";
import colormap from "colormap";
import Spectogram from "wavesurfer.js/dist/plugin/wavesurfer.spectrogram.js";

import { WaveSurfer, WaveForm } from "wavesurfer-react";
import TimelinePlugin from "wavesurfer.js/dist/plugin/wavesurfer.timeline.min";

function SoundChart({ audioURL, uid, hideSpectrogram=false }) {
  const [playingNormal, setPlayingNormal] = useState(false);
  const [playTimeNormal, setPlayTimeNormal] = useState(1);
  const [volume, setVolume] = useState(100);
  const [maxAudioNormal, setMaxAudioNormal] = useState(1);
  const [loadingNormal, setLoadingNormal] = useState(true);

  const wavesurferRefNormal = useRef();
  let colors = colormap({
    colormap: "inferno",
    nshades: 256,
    format: "float",
    alpha: 1,
  });
  const handleWSMountNormal = useCallback((waveSurfer) => {
    wavesurferRefNormal.current = waveSurfer;
    let waveObject = wavesurferRefNormal.current;
    if (waveObject) {
      waveObject.mediaControls = true;
      waveObject.load(audioURL);
      waveObject.setWaveColor("#7597c5");
      waveObject.setProgressColor("#4770A8");
      waveObject.on("finish", () => {
        setPlayingNormal(false);
        // waveObject.destroy();
      });
      waveObject.on("ready", () => {
        setMaxAudioNormal(waveObject.getDuration());
      });
      waveObject.on("audioprocess", () => {
        setPlayTimeNormal(waveObject.getCurrentTime());
      });
      waveObject.on("destroy", () => {
        // remove the plugin and clear all event
        // waveObject.destroy();
      });

      waveObject.on("loading", (data) => {
        if (data === 100) {
          setLoadingNormal(false);
          setPlayingNormal(false);
          setPlayTimeNormal(0);
        }
      });

      if (window) {
        window.surferidze = waveObject;
      }
    }
  });
  const pluginsNormal = [
    {
      plugin: TimelinePlugin,
      options: {
        container: "#timeline-normal-" + uid,
      },
    },
    {
      plugin: Spectogram,
      options: {
        colorMap: colors,
        frequencyMax: 8048,
        fftSamples: 1024,
        container: "#wave-spectrogram-" + uid,
        labels: true,
        height: 256,
      },
    },
  ];

  return (
    <div>
      <div>
        <div className={loadingNormal ? "hidden" : ""}>
          <audio controls>
            <source src={audioURL} type="audio/wav" />
            <source src={audioURL} type="audio/mpeg" />
          </audio>
          {audioURL && !hideSpectrogram ?  (
            <WaveSurfer plugins={pluginsNormal} onMount={handleWSMountNormal}>
              <WaveForm
                id={`wave-spectrogram-${uid}`}
                cursorColor="transparent"
              ></WaveForm>
              <div id={`timeline-normal-${uid}`} />
            </WaveSurfer>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default SoundChart;
